import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ActionItem } from './ActionItem'
import { useAppDispatch } from 'redux/store'
import { calcLogics } from 'redux/calcBot'
import { useSelector } from 'react-redux'
import { TOWrapper } from '../../components/TradeOption/TradeOption'
import { SelectWithSearch } from 'utils/SelectWithSearch/SelectWithSearch'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useGetInputDataExchangesQuery, useGetInputDataSymbolsQuery, useGetMarketsFromTwoExchangesQuery } from '../../redux/rtkApi/inputDataApi'

import { useGetActionsQuery, useLastProfitQuery } from '../../redux/rtkApi/actionsApi'
import { ReactComponent as TableViewIcon } from 'assets/icons/tableView.svg'
import { ReactComponent as BlockViewIcon } from 'assets/icons/blockView.svg'
import { ReactComponent as BugIcon } from 'assets/icons/bug.svg'
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg'
import { ReactComponent as PolyChartIcon } from 'assets/icons/bar-polyline.svg'
import { ReactComponent as LBTIcon } from 'assets/icons/lbtCoin.svg'
import { ReactComponent as USDTIcon } from '../../assets/icons/tether.svg'
import {
  ButtonsCol,
  DeltaCol,
  ExCol,
  ExpectedProfitCol,
  FeeCol,
  FilledCol,
  LogicTypeCol,
  MarketCol,
  PriceCol,
  ProfitCol,
  VolumeCol,
  StatusesCol,
  TimeCol,
} from './TableItem/TableItem.styled'
import { colorsEnum, theme } from '../../utils/GlobalStyles'
import { Charts } from './Charts/Charts'
import { IChartTypesState, TimeIntervalsEnum } from './types'
import { defaultChartTypes } from './constants'
import { useGetChartsOfInvestorsQuery, useGetChartsQuery } from '../../redux/rtkApi/chartsApi'
import { ReactComponent as LBT_Icon } from '../../assets/icons/BOT_LOGO_BLUE.svg'
import { ReactComponent as LBT_Icon_green } from '../../assets/icons/BOT_LOGO_GREEN.svg'
import { ReactComponent as LBT_Icon_red } from '../../assets/icons/BOT_LOGO_RED.svg'
import { TableItem } from './TableItem/TableItem'
import { imageLink, numByPrecision } from '../../utils/utils'
import { emptyAllBalances } from '../../redux/rtkApi/constants'
import { useGetBalancesQuery } from '../../redux/rtkApi/balancesApi'
import { FlagComponent } from '../../components/Header/Flag'
import { useConnectionQuery } from '../../redux/rtkApi/connectionApi'
import { Helmet } from 'react-helmet'
import { useGetBackupsQuery } from '../../redux/rtkApi/withdrawApi'
import { LBTChart } from './LBTChart'
import { timerByFilter } from './utils'
export const ActionsList: React.FC = () => {
  const dispatch = useAppDispatch()

  const [name] = useState(localStorage.getItem('login_name') || '')
  useEffect(() => {
    const randomToken = `${Date.now().toString(36)}-${(Math.random() * 666).toString(36)}-${Date.now().toString(36)}`
    dispatch(calcLogics.actions.setToken({ code: randomToken, name }))
  }, [])

  const token = useSelector(calcLogics.selectors.selectToken)

  const { data: exchangesForSelect = [], isLoading: exchangesLoading } = useGetInputDataExchangesQuery('', {
    refetchOnMountOrArgChange: true,
  })
  const {
    firstEx: filterByFirstExchange,
    secondEx: filterBySecondExchange,
    market: filterByFirstMarket,
    secondMarket: filterBySecondMarket,
  } = useSelector(calcLogics.selectors.selectActionsFilterByExchange)
  const actionIsOpen = useSelector(calcLogics.selectors.selectIsActionOpen)
  const [filterByLogicType, setFilterByLogicType] = useState('All')

  const [showFilterByTO, setShowFilterByTO] = useState(false)
  const [showFilterByDate, setShowFilterByDate] = useState(false)

  const [timeIndex, setTimeIndex] = useState(0)
  const [isLast24H, setIsLast24H] = useState(true)
  const [isLastHour, setIsLastHour] = useState(false)
  const [isFailedOnly, setIsFailedOnly] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const [startTime, setStartTime] = useState(Date.now() - 1000 * 60 * 60 * 24 * 10)
  const [endTime, setEndTime] = useState(Date.now())
  const [page, setPage] = useState(1)
  const [isCancelling, setIsCancelling] = useState(false)
  const [totalLBT, setTotalLBT] = useState(1)
  const [chartTypes, setChartTypes] = useState<IChartTypesState>(defaultChartTypes)
  const [showGeneralChart, setShowGeneralChart] = useState(true)
  const [timeInterval, setTimeInterval] = useState<TimeIntervalsEnum>(TimeIntervalsEnum.HOUR)
  const [isChartsOpened, setIsChartsOpened] = useState(false)

  const {
    data: chartsData = { isGeneralChart: false, byTime: [], grow: [] },
    isLoading,
    isFetching,
  } = useGetChartsQuery(
    {
      showGeneralChart,
      settings: {
        showAll: showAll,
        last24h: isLast24H,
        lastHour: isLastHour,
        isFailedOnly,
        firstEx: filterByFirstExchange,
        secondEx: filterBySecondExchange,
        market: filterByFirstMarket,
        secondMarket: filterBySecondMarket,
        logicType: filterByLogicType,
        startTime,
        endTime,
        timeIndex,
      },
      timeInterval,
      isWithChart: isChartsOpened,
    },
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: 2000,
    }
  )
  const { data: balances = emptyAllBalances, isLoading: isLoadingBalances } = useGetBalancesQuery(
    { onlyForEnabled: false }, //enabledToFilter },
    {
      pollingInterval: 2000,
      refetchOnMountOrArgChange: true,
    }
  )
  const {
    data: chartsDataI = { investors: [], total_token_balance: 0 },
    isLoading: iL,
    isFetching: iF,
  } = useGetChartsOfInvestorsQuery(
    {
      showGeneralChart,
      settings: {
        showAll: showAll,
        last24h: isLast24H,
        lastHour: isLastHour,
        isFailedOnly,
        firstEx: filterByFirstExchange,
        secondEx: filterBySecondExchange,
        market: filterByFirstMarket,
        secondMarket: filterBySecondMarket,
        logicType: filterByLogicType,
        startTime,
        endTime,
        timeIndex,
      },
      timeInterval,
      isWithChart: isChartsOpened,
      username: name,
    },
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: 2000,
    }
  )
  const LBTPrice = chartsDataI?.total_token_balance > 0 ?balances.fiatTotal / chartsDataI.total_token_balance : 1

  const { data: backups } = useGetBackupsQuery(
    {},
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: 1000,
    }
  )
  useGetInputDataSymbolsQuery(
    {},
    {
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
    }
  )
  const { data: exchangesSameMarkets = [], isLoading: marketsLoading } = useGetMarketsFromTwoExchangesQuery(
    { exchange: filterByFirstExchange, secondExchange: filterBySecondExchange },
    { refetchOnFocus: true, refetchOnMountOrArgChange: true }
  )
  const [isTableView, setTableView] = useState(localStorage.getItem('isTableActionsView') === 'true')

  const filterByClickedAction = ({
    firstExchange,
    secondExchange,
    market,
    secondMarket,
  }: {
    firstExchange: string
    secondExchange: string
    market: string
    secondMarket: string | undefined
  }) => {
    dispatch(
      calcLogics.actions.editActionsFilterByExchange({
        firstEx: firstExchange,
        secondEx: secondExchange,
        market,
        secondMarket: secondMarket && market !== secondMarket ? secondMarket : 'All',
      })
    )
  }

  const { data: actions } = useGetActionsQuery(
    {
      startTime,
      endTime,
      page,
      timeIndex,
      showAll: showAll,
      last24h: isLast24H,
      lastHour: isLastHour,
      isFailedOnly,
      firstEx: filterByFirstExchange,
      secondEx: filterBySecondExchange,
      market: filterByFirstMarket,
      secondMarket: filterBySecondMarket,
      logicType: filterByLogicType,
    },
    {
      pollingInterval: 1000,
      skip: actionIsOpen,
    }
  )
  const { data: lastProfit } = useLastProfitQuery('', {
    pollingInterval: 2000,
  })
  useEffect(() => {
    if (lastProfit?.lastProfit && lastProfit?.timestamp && Date.now() - lastProfit?.timestamp < 2000) {
      if (lastProfit.lastProfit > 0) {
        document.title = `LittleBot +${lastProfit.lastProfit.toFixed(2)}$`
      } else {
        document.title = `LittleBot ${lastProfit.lastProfit.toFixed(2)}$`
      }
    }
    return () => {}
  }, [lastProfit])
  const actionsList = actions?.actions || []
  const actionsInfo = {
    totalProfit: chartsData?.stats?.profit || 0,
    totalFee: chartsData?.stats?.fee || 0,
    pureProfit: chartsData?.stats?.pureProfit || 0,
    posProfit: chartsData?.stats?.posProfit || 0,
    negProfit: chartsData?.stats?.negProfit || 0,
    fullVolume: chartsData?.stats?.fullVolume || 0,
    actions24count: chartsData?.stats?.count || 0,
    pagesCount: actions?.fields.pagesCount || 0,
    expectedProfit: chartsData?.stats?.expectedProfit || 0,
    expectedProfitPercent: chartsData?.stats?.expectedProfitPercent || 0,
    avgTimeBetweenOrders: chartsData?.stats?.avgTimeBetweenOrders || 0,
  }

  const { data: connections } = useConnectionQuery(
    { token: token ? token : '', name },
    {
      skip: !token,
      pollingInterval: 2000,
    }
  )

  useEffect(() => {
    if (isCancelling) {
      setTimeout(() => {
        setIsCancelling(false)
      }, 15000)
    }
  }, [isCancelling])
  // useEffect(() => {
  //   if (chartsDataI) {
  //     // let total_lbt = 0
  //     // chartsDataI.investors.forEach(item => {
  //     //   total_lbt += item._id.token_balance
  //     // })
  //     if (chartsDataI.total_token_balance > 0) {
  //       const lbtPriceCounted = balances.fiatTotal / chartsDataI.total_token_balance
  //       setLBTPrice(lbtPriceCounted)
  //       // setTotalLBT(total_lbt)
  //     } else {
  //       setLBTPrice(1)
  //       // setTotalLBT(0)
  //     }
  //   }
  // }, [chartsDataI])

  // const filtered_charts_data = [...chartsDataI.investors].filter((investor) => investor._id.name === name)

  return (
    <Wrapper>
      <Helmet>
        <link
          rel="icon"
          href={
            lastProfit?.lastProfit && lastProfit?.timestamp && Date.now() - lastProfit?.timestamp < 2000
              ? lastProfit.lastProfit > 0
                ? '/logo_green.svg'
                : '/logo_red.svg'
              : '/logo_blue.svg'
          }
        />
      </Helmet>

      <ActionsHeader>
        {lastProfit?.lastProfit && lastProfit?.timestamp && Date.now() - lastProfit?.timestamp < 2000 ? (
          lastProfit.lastProfit > 0 ? (
            <LBT_Icon_green />
          ) : (
            <LBT_Icon_red />
          )
        ) : (
          <LBT_Icon />
        )}
        <RightBlock>
          <div style={{ display: 'flex', width: '9%', justifyContent: 'space-between', height: '12px', alignItems: 'center' }}>
            <UsersOnline>
              👤:{' '}
              <span
                style={{
                  marginLeft: '5px',
                  minWidth: '10px',
                }}
              >
                {' '}
                {connections && connections.filter(item => !item.isFinished).length}
              </span>
              <UsersDetails>
                <UsersDetailsRow isHead>
                  <div>№</div>
                  <div>PID/Type</div>
                  <div>Start</div>
                  <div>End</div>
                  <div>Name</div>
                </UsersDetailsRow>
                <ValuesBlock>
                  {connections
                    ? [...connections]
                        .sort((prev, next) => {
                          const prevTime = prev.end ? prev.end : new Date().getTime()
                          const nextTime = next.end ? next.end : new Date().getTime()
                          if (prevTime > nextTime) return -1
                          return 1
                        })
                        .map((item, index) => (
                          <UsersDetailsRow key={index}>
                            <div>{index + 1}.</div>
                            <div>{item.device}</div>
                            <div>{new Date(item.start).toLocaleString()}</div>
                            <div style={{ color: !item.end ? '#56BC7C' : '#fff' }}>
                              {item.end ? new Date(item.end).toLocaleString() : 'Still active'}
                            </div>
                            <div>{item.name}</div>
                          </UsersDetailsRow>
                        ))
                    : []}
                </ValuesBlock>
              </UsersDetails>
            </UsersOnline>
            <FlagComponent />
          </div>
        </RightBlock>
      </ActionsHeader>
      <LBTChart lbtPrice={LBTPrice} backups={backups || 0} lastProfit={lastProfit?.lastProfit || 0} />
      <Widgets>
        <UserAndTechInfoWrapper>
          <TotalBalanceWrapper>
            <UsersBalanceContainer>
              <UserRow
                style={{
                  height: '20px',
                  color: theme.alabasterWhite,
                  marginTop: '5px',
                  // padding: '0 5px'
                }}
              >
                <div>Investor:</div>
                <div>LBT Amount:</div>
                <div>LBT Total Price($):</div>
                <div>Fee:</div>
                <div style={{ paddingLeft: '1%' }}>Profit($):</div>
              </UserRow>
              {[...chartsDataI.investors]
                .sort((a, b) => {
                  if (a._id.name > b._id.name) {
                    return 1
                  }
                  if (a._id.name < b._id.name) {
                    return -1
                  }
                  return 0
                })
                .map(item => (
                  <UserRow>
                    <div>{item._id.name}</div>
                    <div>
                      {item._id.token_balance}{' '}
                      <SvgIconWrapper>
                        <LBTIcon />
                      </SvgIconWrapper>
                    </div>
                    <div>
                      {item._id.token_balance ? numByPrecision('USDT', item._id.token_balance * LBTPrice) : 0}
                      <USDTIcon
                        style={{
                          marginLeft: '4px',
                          width: '10px',
                          height: '10px',
                        }}
                      />
                    </div>
                    <div>{item._id.fee * 100}%</div>
                    <div>
                      {item.pureProfit ? numByPrecision('USDT', item.pureProfit) : 0}{' '}
                      <USDTIcon
                        style={{
                          marginLeft: '4px',
                          width: '10px',
                          height: '10px',
                        }}
                      />
                    </div>
                  </UserRow>
                ))}
            </UsersBalanceContainer>
          </TotalBalanceWrapper>
          <ProfitBalanceContainer>
            <BalanceBlock>
              <BalanceInfo isTotal>
                TOTAL BALANCE ($): <span>{balances.fiatTotal.toFixed(2)}</span>
                <USDTIcon
                  style={{
                    marginLeft: '4px',
                    width: '10px',
                    height: '10px',
                  }}
                />
              </BalanceInfo>
              <BalanceInfo>
                LBT BALANCE: <span>{chartsDataI.total_token_balance}</span>
                <SvgIconWrapper>
                  <LBTIcon />
                </SvgIconWrapper>
              </BalanceInfo>
              <BalanceInfo>
                LBT PRICE ($): <span>{LBTPrice.toFixed(4)}</span>
                <USDTIcon
                  style={{
                    marginLeft: '4px',
                    width: '10px',
                    height: '10px',
                  }}
                />
              </BalanceInfo>
            </BalanceBlock>

            <BalanceBlock style={{ borderRight: 'none' }}>
              <ProfitInfo color={'blue'} isPure>
                PURE PROFIT: <span>{actionsInfo.pureProfit}</span>
              </ProfitInfo>
              <ProfitInfo color={'alabasterWhite'}>
                GROSS PROFIT: <span>{actionsInfo.totalProfit}</span>
              </ProfitInfo>
              <ProfitInfo color={'yellow'}>
                FEE: <span>{actionsInfo.totalFee}</span>
              </ProfitInfo>
            </BalanceBlock>

            <BalanceBlock style={{ borderRight: 'none' }}>
              <ProfitInfo color={'green'} fullColor>
                + <span> {actionsInfo.posProfit} </span>
              </ProfitInfo>
              <ProfitInfo color={'red'} fullColor>
                - <span> {Math.abs(actionsInfo.negProfit)} </span>
              </ProfitInfo>
              <ProfitInfo color={'feeBlue'}>
                mI%: <span>{((actionsInfo.negProfit / actionsInfo.posProfit) * 100).toFixed(2)}</span>
              </ProfitInfo>
            </BalanceBlock>

            <BalanceBlock style={{ borderRight: 'none' }}>
              <ProfitInfo color={'orange'}>
                EXP: <span>{actionsInfo.expectedProfit}</span>
              </ProfitInfo>
              <ProfitInfo color={'pink'}>
                ESI:% <span>{((actionsInfo.totalProfit / actionsInfo.expectedProfit) * 100).toFixed(2)}</span>
              </ProfitInfo>
              <ProfitInfo color={'purple'}>
                EXP%: <span>{actionsInfo.expectedProfitPercent}</span>
              </ProfitInfo>
            </BalanceBlock>
          </ProfitBalanceContainer>
          <MetricsContainer>
            <BalanceBlock style={{ borderRight: 'none' }}>
              <ProfitInfo color={'alabasterWhite'}>
                VOLUME: <span>{actionsInfo.fullVolume}</span>
              </ProfitInfo>
              <ProfitInfo color={'alabasterWhite'}>
                ACTIONS: <span>{actionsInfo.actions24count}</span>
              </ProfitInfo>
              <ProfitInfo color={'lightBlue'}>
                AVG TIME: <span>{actionsInfo.avgTimeBetweenOrders}</span>
              </ProfitInfo>
            </BalanceBlock>
          </MetricsContainer>
        </UserAndTechInfoWrapper>
        <TimeButtonLogicTypeWrapper>
          <TimeButtons>
            <FilterType>
              <TimeRangeWrapper>
                <TimeWrapper>
                  {' '}
                  {isLastHour || isLast24H ? (
                    <TimeRange> {timerByFilter({ isLastHour, isLast24H, timeIndex })}</TimeRange>
                  ) : (
                    <TimeRange>(08/05/2022 - present)</TimeRange>
                  )}
                </TimeWrapper>
                <TimeIndexBlock isHourOrDayFilter={isLastHour || isLast24H}>
                  <TimeIndexButton onClick={() => setTimeIndex(prev => prev + 1)}>{'<'}</TimeIndexButton>
                  <TimeIndex>{timeIndex}</TimeIndex>
                  <TimeIndexButton onClick={() => setTimeIndex(prev => prev - 1)}>{'>'}</TimeIndexButton>
                </TimeIndexBlock>
                <FilterButtonsContainer>
                  <DatePickerButton
                    isActive={showAll}
                    onClick={() => {
                      setPage(1)
                      setShowAll(true)
                      setIsLast24H(false)
                      setIsLastHour(false)
                      setTimeIndex(0)
                    }}
                  >
                    ALL
                  </DatePickerButton>
                  <DatePickerButton
                    isActive={isLast24H}
                    onClick={() => {
                      setPage(1)
                      setShowAll(false)
                      setIsLast24H(true)
                      setIsLastHour(false)
                      setTimeIndex(0)
                    }}
                    data-title={'By last 24 hour'}
                  >
                    24H
                  </DatePickerButton>
                  <DatePickerButton
                    isActive={isLastHour}
                    onClick={() => {
                      setPage(1)
                      setShowAll(false)
                      setIsLast24H(false)
                      setIsLastHour(true)
                      setTimeIndex(0)
                    }}
                  >
                    1H
                  </DatePickerButton>
                  <FailedWrapper
                    onMouseOver={() => setShowFilterByDate(true)}
                    onMouseLeave={() => setShowFilterByDate(false)}
                    style={{
                      marginLeft: '10px',
                      width: '30px',
                    }}
                    data-title={'By last hour'}
                  >
                    <CalendarIcon
                      style={{
                        fill: !showAll && !isLast24H && !isLastHour ? theme.green : theme.white33,
                        width: '15px',
                        height: '15px',
                        marginLeft: '5px',
                        position: 'absolute',
                        top: '-1px',
                      }}
                    />
                    {showFilterByDate && (
                      <div>
                        <FilterWrapper style={{ top: '14px' }}>
                          <DatePickerWrapper>
                            <DatePickerName>From</DatePickerName>
                            <DatePicker
                              showTimeSelect
                              showTimeInput
                              dateFormat="dd/MM/yyyy HH:mm:ss"
                              selected={new Date(startTime)}
                              onChange={date => {
                                setShowAll(false)
                                setIsLast24H(false)
                                setIsLastHour(false)
                                setStartTime(new Date(date as Date).getTime())
                              }}
                              popperPlacement="bottom-end"
                            />
                          </DatePickerWrapper>

                          <DatePickerWrapper>
                            <DatePickerName>To</DatePickerName>
                            <DatePicker
                              showTimeSelect
                              showTimeInput
                              dateFormat="dd/MM/yyyy HH:mm:ss"
                              selected={new Date(endTime)}
                              onChange={date => {
                                setShowAll(false)
                                setIsLast24H(false)
                                setIsLastHour(false)
                                setEndTime(new Date(date as Date).getTime())
                              }}
                              popperPlacement="bottom-end"
                            />
                          </DatePickerWrapper>
                        </FilterWrapper>
                      </div>
                    )}
                  </FailedWrapper>
                </FilterButtonsContainer>
              </TimeRangeWrapper>
              <TimeRangeWrapper>
                <FiltersRowRapper style={{ alignItems: 'center', margin: '5px 0 5px' }}>
                  <Pagination>
                    <PagiButton
                      isEnabled={page !== 1}
                      onClick={() => {
                        if (page > 1) {
                          setPage(1)
                        }
                      }}
                    >
                      {'<<'}
                    </PagiButton>
                    <PagiButton
                      isEnabled={page !== 1}
                      onClick={() => {
                        if (page > 1) {
                          setPage(prev => prev - 1)
                        }
                      }}
                    >
                      {'<'}
                    </PagiButton>
                    <CustomInput
                      value={page}
                      onChange={e => {
                        if (+e.target.value) {
                          setPage(+e.target.value)
                        }
                      }}
                      placeholder="Page"
                      type="number"
                      style={{ width: '40px', height: '14px', fontSize: '12px' }}
                    />
                    <PagiButton
                      isEnabled={page !== actionsInfo.pagesCount}
                      onClick={() => {
                        if (page < actionsInfo.pagesCount) {
                          setPage(prev => prev + 1)
                        }
                      }}
                    >
                      {'>'}
                    </PagiButton>
                    <PagiButton
                      isEnabled={page !== actionsInfo.pagesCount}
                      onClick={() => {
                        if (page < actionsInfo.pagesCount) {
                          setPage(() => actionsInfo.pagesCount)
                        }
                      }}
                    >
                      {'>>'}
                    </PagiButton>
                    <PagiButton isEnabled={true} style={{ width: '50px', cursor: 'default', fontSize: '11px' }}>
                      ({actionsInfo.pagesCount})
                    </PagiButton>
                  </Pagination>

                  <FailedWrapper data-title={'Filter by errors'}>
                    <BugIcon
                      style={{
                        fill: isFailedOnly ? theme.green : theme.white33,
                        width: '15px',
                        height: '15px',
                        marginLeft: '20px',
                        paddingTop: '1px',
                      }}
                      onClick={() => {
                        setPage(1)
                        setIsFailedOnly(prev => !prev)
                      }}
                    />
                  </FailedWrapper>

                  <HoverWrapper onMouseOver={() => setShowFilterByTO(true)} onMouseLeave={() => setShowFilterByTO(false)}>
                    <DatePickerButton
                      isActive={[filterByFirstExchange, filterBySecondExchange, filterByFirstMarket, filterBySecondMarket].some(
                        item => item !== undefined
                      )}
                      onClick={() => {
                        if ([filterByFirstExchange, filterBySecondExchange, filterByFirstMarket, filterBySecondMarket].some(item => item !== 'All')) {
                          dispatch(
                            calcLogics.actions.editActionsFilterByExchange({ firstEx: 'All', secondEx: 'All', market: 'All', secondMarket: 'All' })
                          )
                        }
                      }}
                      style={{
                        width: '40px',
                        marginLeft: '10px',
                        borderRadius: '3px',
                      }}
                    >
                      TO
                    </DatePickerButton>

                    {showFilterByTO && (
                      <FiltersRowRapper>
                        <FilterWrapper secondPlace={showFilterByDate} style={{ top: '16px', left: '10px' }}>
                          <FilterByTO>
                            <FilterExchange>
                              <SelectWrapper>
                                <FilterName>Exchange 1</FilterName>
                                <SelectWithSearch
                                  isLoading={exchangesLoading}
                                  itemsArr={['All', ...exchangesForSelect]}
                                  onSelect={item => dispatch(calcLogics.actions.editActionsFilterByExchange({ firstEx: item }))}
                                  additionalTrigger={filterByFirstExchange}
                                  dontRenewOnListChange
                                />
                              </SelectWrapper>
                              <SelectWrapper>
                                <FilterName>Exchange 2</FilterName>
                                <SelectWithSearch
                                  isLoading={exchangesLoading}
                                  itemsArr={['All', ...exchangesForSelect]}
                                  onSelect={item => dispatch(calcLogics.actions.editActionsFilterByExchange({ secondEx: item }))}
                                  additionalTrigger={filterBySecondExchange}
                                  dontRenewOnListChange
                                />
                              </SelectWrapper>
                            </FilterExchange>
                            <FilterMarket>
                              <SelectWrapper>
                                <FilterName>Market 1</FilterName>
                                <SelectWithSearch
                                  isLoading={marketsLoading}
                                  itemsArr={['All', ...exchangesSameMarkets]}
                                  onSelect={item => dispatch(calcLogics.actions.editActionsFilterByExchange({ market: item }))}
                                  additionalTrigger={filterByFirstMarket}
                                  dontRenewOnListChange
                                />
                              </SelectWrapper>
                              <SelectWrapper>
                                <FilterName>Market 2</FilterName>
                                <SelectWithSearch
                                  isLoading={marketsLoading}
                                  itemsArr={['All', ...exchangesSameMarkets]}
                                  onSelect={item => dispatch(calcLogics.actions.editActionsFilterByExchange({ secondMarket: item }))}
                                  additionalTrigger={filterBySecondMarket}
                                  dontRenewOnListChange
                                />
                              </SelectWrapper>
                            </FilterMarket>
                          </FilterByTO>
                        </FilterWrapper>
                      </FiltersRowRapper>
                    )}
                  </HoverWrapper>
                  <Logic>Logic:</Logic>
                  <FiltersRowRapper style={{ marginLeft: '5px' }}>
                    <LogicTypeButton
                      isActive={filterByLogicType === 'All'}
                      onClick={() => {
                        setFilterByLogicType('All')
                      }}
                    >
                      {'ALL'}
                    </LogicTypeButton>
                    <LogicTypeButton
                      isActive={filterByLogicType === 'MARKET'}
                      onClick={() => {
                        setFilterByLogicType('MARKET')
                      }}
                    >
                      {'M'}
                    </LogicTypeButton>
                    <LogicTypeButton
                      isActive={filterByLogicType === 'LIMIT'}
                      onClick={() => {
                        setFilterByLogicType('LIMIT')
                      }}
                    >
                      {'L'}
                    </LogicTypeButton>
                  </FiltersRowRapper>
                  <IconContainer>
                    <ChartsIconWrapper style={{ paddingBottom: '1px' }} isActive={isChartsOpened} data-title={'Charts'}>
                      <PolyChartIcon onClick={() => setIsChartsOpened(prev => !prev)} />
                    </ChartsIconWrapper>
                    {isTableView ? (
                      <ChartsIconWrapper
                        isActive={false}
                        onClick={() =>
                          setTableView(prev => {
                            localStorage.setItem('isTableActionsView', String(!prev))
                            return !prev
                          })
                        }
                        data-title={'Set block view'}
                      >
                        <BlockViewIcon />
                      </ChartsIconWrapper>
                    ) : (
                      <ChartsIconWrapper
                        isActive={false}
                        onClick={() =>
                          setTableView(prev => {
                            localStorage.setItem('isTableActionsView', String(!prev))
                            return !prev
                          })
                        }
                        data-title={'Set table view'}
                      >
                        <TableViewIcon />
                      </ChartsIconWrapper>
                    )}
                  </IconContainer>
                </FiltersRowRapper>
              </TimeRangeWrapper>
            </FilterType>
          </TimeButtons>
        </TimeButtonLogicTypeWrapper>
      </Widgets>
      {isChartsOpened ? (
        <Charts
          showAll={showAll}
          isLast24H={isLast24H}
          isLastHour={isLastHour}
          chartsData={chartsData}
          chartTypes={chartTypes}
          setChartTypes={setChartTypes}
          timeInterval={timeInterval}
          setTimeInterval={setTimeInterval}
          showGeneralChart={showGeneralChart}
          setShowGeneralChart={setShowGeneralChart}
          isLoading={isLoading}
          isFetching={isFetching}
        />
      ) : isTableView ? (
        <div>
          <TableHeader>
            <LogicTypeCol>Type</LogicTypeCol>
            <TimeCol>Date</TimeCol>
            <ButtonsCol>Details</ButtonsCol>
            <MarketCol>Market</MarketCol>
            <ExCol>Exchange</ExCol>
            <VolumeCol>Volume($)</VolumeCol>
            <PriceCol>
              <span style={{ width: '50%' }}>1st price</span> <span style={{ width: '50%' }}>2nd price</span>
            </PriceCol>
            <FilledCol>Filled</FilledCol>
            <StatusesCol>Statuses</StatusesCol>
            <ExpectedProfitCol>Exp. profit ($)</ExpectedProfitCol>
            <ProfitCol>Profit ($)</ProfitCol>
            <DeltaCol>Delta</DeltaCol>
            <FeeCol>Fee ($)</FeeCol>
            <ProfitCol>Pure profit ($)</ProfitCol>
          </TableHeader>
          {actionsList.map(action => (
            <TableItem {...action} />
          ))}
        </div>
      ) : (
        <Container>
          <Header>
            <Title>TRADE OPTIONS</Title>
            <Title>FIRST ACTION</Title>
            <Title>SECOND ACTION</Title>
            <Title>
              <OrderRow>
                <OrderCol>Exchange</OrderCol>
                <OrderCol>Market</OrderCol>
                <OrderCol style={{ width: '40px' }}>Side</OrderCol>
                <OrderCol style={{ width: '100px' }}>Price</OrderCol>
                <OrderCol>Volume</OrderCol>
                <OrderCol>Filled</OrderCol>
                <OrderCol>isActive</OrderCol>
                <OrderCol style={{ width: '100px' }}>Time</OrderCol>
                <OrderCol style={{ width: '100px' }}>Created</OrderCol>
                <OrderCol style={{ width: '100px' }}>1st res</OrderCol>
                <OrderCol style={{ width: '100px' }}>Updated</OrderCol>
              </OrderRow>
            </Title>
          </Header>
          <ContentBlock>
            {actionsList.map(action => (
              <ActionItem {...action} key={action._id} filterByClickedAction={filterByClickedAction} />
            ))}
          </ContentBlock>
        </Container>
      )}
    </Wrapper>
  )
}
export const HoverWrapper = styled.div`
  position: relative;
  //z-index: 1;
  & > div {
    height: 100%;
  }
  &:first-child {
    cursor: pointer;
  }
`
export const FilterName = styled.div`
  text-wrap: nowrap;
`
export const SelectWrapper = styled.div`
  & > div:last-child > div {
    width: 100px;

    div {
      width: 100px;
    }
  }
`
export const FilterExchange = styled.div`
  display: flex;

  div {
    width: max-content;
  }
`
export const FilterMarket = styled.div`
  display: flex;

  div {
    width: max-content;
  }
`
export const FilterByTO = styled.div``

export const FilterWrapper = styled.div<{ secondPlace?: boolean }>`
  display: flex;
  position: absolute;
  top: ${({ secondPlace }) => (secondPlace ? '270%' : '100%')};
  left: 5%;
  //top: 0;
  background: ${({ theme }) => theme.dark};
  border: 1px solid ${({ theme }) => theme.white33};
  padding: 5px;
  border-radius: 5px;
  z-index: 3;
`

const Widgets = styled.div`
  padding: 10px 1%;
  display: flex;
  //align-items: center;
  min-height: 120px;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
`
export const CustomInput = styled.input`
  background: rgba(255, 255, 255, 0.11);
  border: 0.3px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 1px 1px 1px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding: 1px 5px;
  width: 40px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

const Header = styled.tr``

const ContentBlock = styled.tbody`
  tr:nth-child(2n-1) {
    background: ${({ theme }) => theme.black};

    ${TOWrapper} {
      background: ${({ theme }) => theme.black};
    }
  }
`
const Container = styled.table`
  width: 100%;
  border-collapse: separate;

  td,
  th {
    border: 0.2px solid rgba(255, 255, 255, 0.1);
  }

  ${ContentBlock} {
    max-height: 425px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
      visibility: hidden;
    }
  }
`

const Wrapper = styled.div`
  /* display: flex; */
  width: 100%;
  background: ${({ theme }) => theme.dark};
  border: 0.2px solid rgba(255, 255, 255, 0.1);
  font-family: Arial, sans-serif;
  color: ${({ theme }) => theme.alabasterWhite};
`
const OrderRow = styled.div`
  display: flex;
  position: relative;
  padding: 0;
  border-bottom: 1px solid #ffffff22;

  &:hover {
    background: #ffffff22;
  }

  &:first-child {
    background: #353638;
  }
`
const Title = styled.th`
  padding: 0 10px;

  &:first-child {
    max-width: 175px;
    padding: 0 0 0 10px;
  }

  &:last-child {
    padding: 0;
  }

  &:not(:last-child) {
    min-width: 175px;
    /* max-width: 400px; */
  }
`

const OrderCol = styled.div<{ error?: boolean; color?: string }>`
  width: 65px;
  padding: 1px 2px;
  white-space: nowrap;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 14px;
  //width: 700px;
`

export const InfoBlock = styled.div<{ color?: string }>`
  display: flex;
  margin-left: 5px;
  //font-family: 'Arial', sans-serif;
  span {
    margin: 0 2px;
    color: ${({ color, theme }) => theme.getColorByName(color)};
  }
  &:hover {
    cursor: default;
  }
`
export const DatePickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  //padding-bottom: 13px;
  input {
    width: 150px;
    font-size: 14px;
    background: #ffffff22;
    color: #fff;
    padding: 1px 4px;
    background: rgba(255, 255, 255, 0.11);
    border: 0.3px solid rgba(255, 255, 255, 0.1);
    box-shadow: inset 1px 1px 1px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  }

  .react-datepicker {
    background: #3c434c;
  }

  .react-datepicker__day,
  .react-datepicker__current-month,
  .react-datepicker-time__input,
  .react-datepicker__month-container,
  .react-datepicker__input-time-container,
  .react-datepicker-time__caption,
  .react-datepicker__time-list-item,
  .react-datepicker__time-list {
    background: #3c434c;
    color: #fff;
    border: none;
  }

  .react-datepicker__input-time-container {
    width: 200px !important;
  }

  .react-datepicker__day--outside-month {
    color: #ffffff40;
  }

  .react-datepicker__day--selected,
  .react-datepicker__time-list-item--selected,
  .react-datepicker-time__input,
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker__header {
    background: rgb(41, 48, 56) !important;
    color: ${({ theme }) => theme.yellow}; !important;
  }

  .react-datepicker__day-name {
    background: rgb(41, 48, 56) !important;
    color: #fff !important;
  }

  .react-datepicker__time-list-item:hover {
    background: ${({ theme }) => theme.yellow}; !important;
    color: #000;
  }
`

export const DatePickerName = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 13px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 6px;
`

export const DatePickerButton = styled.button<{ isActive?: boolean }>`
  text-wrap: nowrap;
  overflow: hidden;
  background: ${({ isActive, theme }) => (isActive ? theme.green : undefined)};
  color: ${({ isActive, theme }) => (isActive ? '#000' : theme.white33)};
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.green : theme.white33)};
  border-radius: 3px;
  padding: 0 8px;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
  min-width: 40px;
  max-width: 120px;
  margin-left: 3px;
  height: 14px;
  &:active {
    color: ${({ theme }) => theme.green};
    border: 1px solid;
  }
  &:hover {
    border-color: ${({ theme }) => theme.white66};
    color: ${({ theme }) => theme.white66};
    background: none;
  }
`

export const DatePickerThreeState = styled(DatePickerButton)`
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.green : isActive === undefined ? theme.white33 : theme.red)};
  color: ${({ isActive }) => (isActive ? '#000' : isActive === undefined ? theme.white33 : theme.red)};
`
export const ColorDatePickerButton = styled(DatePickerButton)<{ color: colorsEnum }>`
  background: ${({ isActive, theme, color }) => (isActive ? theme[color] : undefined)};
  // color: ${({ isActive, theme, color }) => (isActive ? '#000' : theme.getColorWithOpacity(color, 80))};
  border: 1px solid ${({ theme, isActive, color }) => (isActive ? theme[color] : undefined)};
  border-bottom: 1px solid ${({ theme, isActive, color }) => (isActive ? '#00000000' : theme[color])};
  &:active {
    color: ${({ theme, color }) => theme[color]};
    border: 1px solid;
  }
`

const LogicTypeButton = styled(DatePickerButton)`
  //margin: 0 2px;
`

export const InfoName = styled.span`
  width: 75px;
  display: flex;
  justify-content: space-between;
`

export const InfoValue = styled.span`
  width: 75px;
  text-align: right;
`

export const Pagination = styled.div`
  display: flex;
  //max-width: 220px;
  margin-left: 10px;
  height: 14px;
  padding-left: 40px;
`

export const PagiButton = styled.button<{ isEnabled?: boolean }>`
  color: ${({ isEnabled, theme }) => (isEnabled ? theme.alabasterWhite : theme.white33)};
  //border: 1px solid ${({ theme }) => theme.white33};
  //border-radius: 2px;
  padding: 0 4px;
  margin: 0 2px;
  height: 12px;
  &:hover {
    color: white;
  }
`

const TimeButtons = styled.div`
  display: flex;
  //margin-left: 2%;
  //width: fit-content;
`

export const TimeIndexBlock = styled.div<{ isHourOrDayFilter?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 10px;
  max-width: 130px;
`

export const TimeIndexButton = styled.button`
  color: ${({ theme }) => theme.white33};
  padding: 0 8px;
  margin: 0 4px;
  height: 14px;
  font-weight: 500;
  &:hover {
    color: #fff;
    border-color: #fff;
  }
`

export const FilterType = styled.div`
  display: flex;
  //justify-content: space-evenly;
  align-items: center;
  //width: 600px;
  //max-height: 50px;
  //margin-top: 5px;
  //margin-bottom: 10px;
  //padding-left: 2%;
`
export const TimeIndex = styled.div`
  width: 20px;
  text-align: center;
`

export const FailedWrapper = styled.div`
  //width: 50px;
  position: relative;
  &:hover {
    cursor: pointer;
  }
`

export const TimeButtonLogicTypeWrapper = styled.div`
  display: flex;
  //width: 100%;
  //flex-direction: column;
  //height: 50px;
  //justify-content: space-between;
  //margin-bottom: -30px;
  margin-top: 15px;
  margin-bottom: 10px;
`

export const TimeRange = styled.div`
  max-width: 120px;
  font-size: 10px;
  text-align: center;
`
export const TimeRangeWrapper = styled.div`
  display: flex;
  //flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
`
const IconWrapper = styled.div`
  svg {
    width: 24px;
    height: 24px;
    fill: ${({ theme }) => theme.white66};
    path {
      fill: ${({ theme }) => theme.white66};
    }
  }
  &:hover {
    cursor: pointer;
    svg {
      fill: #fff;
      path {
        fill: #fff;
      }
    }
  }
`

const TableHeader = styled.div`
  display: flex;
  width: 100%;
  color: ${({ theme }) => theme.alabasterWhite};
`
export const TimeWrapper = styled.div`
  padding-left: 5px;
`
export const Profit = styled.span`
  font-family: 'Arial', sans-serif;
  font-size: 11px;
  text-wrap: nowrap;
`
export const ProfitDescription = styled.span`
  font-size: 10px;
`
const Logic = styled.span`
  font-size: 10px;
  margin-left: 10px;
`
const FiltersRowRapper = styled.div`
  display: flex;
`
const FilterIconWrapper = styled.div`
  position: absolute;
  left: 258px;
  top: 50px;
  font-size: 10px;
`
export const FilterButtonsContainer = styled.div`
  display: flex;
  margin: 5px 0 5px 0;
`
const IconContainer = styled.div`
  position: relative;
  display: flex;
`
const ChartsIconWrapper = styled.div<{ isActive: boolean }>`
  margin-left: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 18px;
    height: 18px;
    color: ${({ theme, isActive }) => (isActive ? theme.green : theme.white33)};
    fill: ${({ theme, isActive }) => (isActive ? theme.green : theme.white33)};
  }
  &:hover {
    cursor: pointer;
    svg {
      fill: ${({ theme, isActive }) => (isActive ? theme.green : theme.white66)};
    }
  }
`
const TotalBalanceWrapper = styled.div`
  height: 100%;
  display: flex;
  width: 40%;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.white33};
  border-radius: 5px;
  padding: 5px 20px;
`
const BalancesRow = styled.div`
  display: flex;
  height: 22px;
  align-items: center;
  &:nth-child(2) {
    margin-left: 20px;
  }
  &:nth-child(3) {
    margin-left: 20px;
  }
`
const UsersBalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 176px;
  overflow-y: scroll;
  border-radius: 3px;
  padding: 2px 0;

  &::-webkit-scrollbar {
    visibility: hidden;
    width: 0;
  }
`
const UserRow = styled.div`
  display: flex;
  margin: 3px 0;
  color: ${({ theme }) => theme.white33};
  div {
    display: flex;
    align-items: center;
    margin: 0 2px;
    text-wrap: nowrap;
    overflow: hidden;
    cursor: default;
    &:nth-child(1) {
      width: 25%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 15%;
    }
    &:nth-child(5) {
      //justify-content: center;
      width: 20%;
      padding-left: 1%;
    }
  }
  &:hover {
    color: ${({ theme }) => theme.alabasterWhite};
  }
`
const BalanceInfo = styled.div<{ isTotal?: boolean }>`
  color: ${({ theme, isTotal }) => (isTotal ? theme.white66 : theme.white33)};
  font-size: 11px;
  display: flex;
  align-items: center;
  margin: 5px 0;
  padding-left: 10px;
  cursor: default;
  span {
    //text-align: end;

    padding-left: 5px;
    color: ${({ theme, isTotal }) => (isTotal ? theme.alabasterWhite : theme.green)};
  }
`
const ProfitInfo = styled.div<{ isPure?: boolean; color: string; fullColor?: boolean }>`
  color: ${({ theme, isPure, fullColor, color }) => (fullColor ? theme[color] : isPure ? theme.white66 : theme.white33)};
  font-size: 11px;
  display: flex;
  margin: 5px 0;
  padding-left: 10px;
  text-wrap: nowrap;
  cursor: default;
  span {
    justify-content: space-between;
    width: 70px;
    padding-left: 5px;
    color: ${({ theme, color }) => theme[color]};
  }
`
const EmptyProfitInfo = styled.div<{ isPure?: boolean; color: string }>`
  color: rgba(0, 0, 0, 0);
  font-size: 11px;
  display: flex;
  margin: 5px 0;
  padding-left: 10px;
  text-wrap: nowrap;
  user-select: none;
  span {
    //text-align: end;
    user-select: none;
    width: 70px;
    padding-left: 5px;
    color: rgba(0, 0, 0, 0);
  }
`
const UserAndTechInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`
const ProfitBalanceContainer = styled.div`
  //height: 100%;
  display: flex;
  width: 48%;
  //flex-direction: column;
  border: 1px solid ${({ theme }) => theme.white33};
  border-radius: 5px;
  padding: 5px 0;
  justify-content: space-around;
  //padding-right: 20px;
`
const MetricsContainer = styled.div`
  //height: 100%;
  display: flex;
  width: 10%;
  //flex-direction: column;
  border: 1px solid ${({ theme }) => theme.white33};
  border-radius: 5px;
  padding: 5px 0;
  //padding-right: 20px;
`
const BalanceBlock = styled.div<{ isPos?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 32px 20px 32px 0;
  border-right: 1px solid ${({ theme }) => theme.white33};
  justify-content: ${({ isPos }) => (isPos ? 'space-around' : 'space-between')};
  //min-width: 20%;
`

const SvgIconWrapper = styled.div`
  margin-left: 4px;
  display: flex;
  align-items: center;
  svg {
    width: 11px;
    height: 11px;
  }
`
export const IconImg = styled.div<{ src: string }>`
  position: relative;
  margin-left: 4px;
  height: 11px;
  width: 11px !important;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`
const ActionsHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 3px 1.5%;
`

const UsersDetails = styled.div`
  padding-top: 4px;
  display: none;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  transform: translateY(100%);
  border-radius: 6px;
`

const ValuesBlock = styled.div`
  border-radius: 0 0 6px 6px;
  max-height: 400px;
  overflow-y: auto;
`

const UsersDetailsRow = styled.div<{ isHead?: boolean }>`
  display: flex;

  padding: ${({ isHead }) => (isHead ? '6px 8px' : '4px 8px')};
  font-weight: ${({ isHead }) => (isHead ? '500' : '400')};
  background: ${({ isHead, theme }) => (isHead ? theme.darkGray : theme.gray)};
  border-radius: ${({ isHead }) => (isHead ? '6px 6px 0 0' : 0)};

  div {
    display: flex;
    align-items: center;
    margin: 0 2px;

    &:nth-child(1) {
      width: 25px;
    }

    &:nth-child(2) {
      //width: 200px;
      width: 120px;
    }

    &:nth-child(3) {
      width: 150px;
    }

    &:nth-child(4) {
      width: 150px;
    }

    &:nth-child(5) {
      width: 150px;
    }
  }
`

const UsersOnline = styled.div`
  position: relative;
  font-size: 12px;
  display: flex;
  margin-left: 5px;
  padding: 2px 6px 2px 6px;
  border: none;
  box-shadow: inset 0 0 0.5px rgba(255, 255, 255, 0.27);
  border-radius: 6px;
  margin-right: 10px;
  &:hover {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), ${({ theme }) => theme.dark};

    ${UsersDetails} {
      display: block;
    }
  }

  span {
    color: ${({ theme }) => theme.green};
  }
`

export const RightBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 100px;
  font-size: 14px;
`
